// extracted by mini-css-extract-plugin
module.exports = {"stripe":"HomeTemplate_stripe__iiNdY","rotation":"HomeTemplate_rotation__66Vq_"};